import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\" id=\"arrow-right\"><path d=\"M566.058667 179.626667a32 32 0 0 0-44.117334 46.293333l266.709334 254.08H160a32 32 0 0 0 0 64h628.650667l-266.709334 254.08a32 32 0 0 0 44.117334 46.336l316.586666-301.525333a42.453333 42.453333 0 0 0 12.8-24.746667 32.298667 32.298667 0 0 0-0.042666-12.330667 42.453333 42.453333 0 0 0-12.8-24.704l-316.544-301.525333z\" p-id=\"5232\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol